// extracted by mini-css-extract-plugin
export default {"flexGroup":"IncomingMaterialsView_flexGroup__lslJj","h5":"IncomingMaterialsView_h5__UFJWN"};